// ============================================
// FILE: apiSetup/apiConfig.ts
// ============================================

import { isBeta } from '../config/env';

let API_BASE_URL: string;
// Node socket server (live gate dashboard). Same host as the API when Nginx
// forwards /socket.io/ to the Node service; no trailing path needed.
let SOCKET_BASE_URL: string;

if (isBeta) {

  API_BASE_URL = 'https://beta-skoolpillar-api.skoolpillar.com/';
  SOCKET_BASE_URL = 'https://beta-skoolpillar-api.skoolpillar.com';

} else if (process.env.NODE_ENV === 'production') {

  API_BASE_URL = 'https://skoolpillar-api.skoolpillar.com/';
  SOCKET_BASE_URL = 'https://skoolpillar-api.skoolpillar.com';

} else {

  // url that connects to the localhost
  
  API_BASE_URL = 'https://dev-api.skoolpillar.cloud/';
  // API_BASE_URL = 'https://beta-skoolpillar-api.skoolpillar.com/';

    SOCKET_BASE_URL = 'http://localhost:3016';
  // Node running on your Mac (SOCKET_PORT in the Node .env):
  // SOCKET_BASE_URL = 'http://localhost:3016';

}

export { API_BASE_URL, SOCKET_BASE_URL };